import React from "react";
import { Helmet } from "react-helmet";

const MetaTags = ({ metaData }) => {
    return (

        <Helmet>

            {metaData.map((meta, index) => (
                <div key={index}>
                    <title>{meta.title}</title>
                    <meta name="description" content={meta.description} />
                    <meta name="keywords" content={meta.keywords.join(", ")} />
                </div>
            ))}

        </Helmet>


    );
};

export default MetaTags;
